<aside [@shrinkAnimation]="shrinkState" class="flex-column pd-s shrinkable-div" id="kpi-sidebar">
  <div
    [ngClass]="
      {'flex-row': shrinkState === 'expanded',
       'flex-column shrunken-state': shrinkState === 'shrunken'
      }"
    class="icons-container"
  >
    <i class="fa-sharp fa-light fa-chart-line primary-color"></i>
    <button (click)="shrinkDiv()" color="primary" mat-icon-button>
      <i
        [ngClass]="
        {'fa-arrow-left': shrinkState === 'expanded',
         'fa-arrow-right': shrinkState === 'shrunken'
        }"
        class="fa-sharp fa-light"
      ></i>
    </button>
  </div>
  <section *ngIf="shrinkState === 'expanded'" class="sidebar-container flex-column">
    <ng-content select="[kpi-header]"></ng-content>
    <div
      *ngFor="let item of sidebar"
      [attr.id]="item.id || null"
      [ngClass]="[
        'sidebar-item',
        'flex-column',
        'flex-centered',
        'pd-l-m',
        'pd-r-m',
        item.class || ''
      ]"
    >
      <ng-container *ngIf="item.type === 'chart'">
          <ag-charts
            [options]="item.chart!.options!">
          </ag-charts>
          <span class="sidebar-item-title">{{ item.title }}</span>
      </ng-container>
      <ng-container *ngIf="!item.type || item.type === 'simple'">
        <span class="sidebar-item-value">{{ item.value === 0 ? '-' : item.value }}</span>
        <span class="sidebar-item-title">{{ item.title }}</span>
      </ng-container>
    </div>
    <ng-content select="[kpi-footer]"></ng-content>
  </section>
</aside>

